import { Container } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';
import { COLOR_TOKEN } from '../../../helpers/color-tokens';

export const AlertsContainer = styled(Container)`
	background: ${COLOR_TOKEN.background.secondary};
	padding-left: 4.16vw;
	padding-right: 4.16vw;
`;

export const AlertsStackedContainer = styled(Container)`
	display: flex;
	flex-direction: column;
	> div {
		justify-content: space-between;
		> div {
			@media (max-width: 960px) {
				width: 100%;
			}
		}
	}
`;

export const FlexItem = styled.div<{ paddingRight: boolean; paddingBottom: boolean }>`
	height: 100%;
	padding-right: ${({ paddingRight }: { paddingRight: boolean }) => (paddingRight ? 'var(--size-grid001)' : '0')};
	padding-bottom: ${({ paddingBottom }: { paddingBottom: boolean }) =>
		paddingBottom ? 'var(--size-grid001)' : 'var(--size-dynamic0020)'};

	@media (max-width: 960px) {
		padding-bottom: ${({ paddingBottom }: { paddingBottom: boolean }) =>
			paddingBottom ? 'var(--size-grid001)' : 'var(--size-grid001)'};
		padding-right: 0px;
	}
`;
